import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS } from 'scenes/Permissions/constants/permissions';
import { selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness } from 'scenes/Permissions/store/selectors/personalPermissionsSelectors';
import { calendarOpenNextWeek } from '../actions/demoActions';
import { selectIsPersonalWorkCalendarMode } from '../selectors/base-work-calendar.selectors';
import {
  selectFetchedWeekNumbers,
  selectWorkSearchParamsVisibleWeeks,
} from '../selectors/workSearchParamsSelectors';
import { loadAdminCalendarFilesDataInTimeframe } from './loadAdminCalendarFilesDataInTimeframe.thunk';
import { loadAdminCalendarRecordsDataInTimeframe } from './loadAdminCalendarRecordsDataInTimeframe.thunk';
import { loadCalendarDataInTimeframe } from './loadCalendarDataInTimeframe.thunk';
import { loadPersonalWorkCalendarData } from './my-lixani/loadPersonalWorkCalendarData.thunk';

export const setOpenNextWeek = createAsyncThunk(
  'workCalendar/setOpenNextWeek',
  async (_, { dispatch, getState }) => {
    const state = getState();

    const isPermissionFromActiveEmployerToViewAllBusinessRecords =
      selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness(
        getState(),
        WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS
      );

    const visibleWeeks = selectWorkSearchParamsVisibleWeeks(state);

    const fetchedWeeks = selectFetchedWeekNumbers(state);

    const isPersonalWorkCalendarMode = selectIsPersonalWorkCalendarMode(state);

    const weekISO =
      visibleWeeks.length > 0
        ? visibleWeeks[visibleWeeks.length - 1]
        : dayjs().startOf('isoWeek').format();

    const nextWeek = dayjs(weekISO).add(1, 'week').format();

    const nextWeekNumber = dayjs(nextWeek).format('GGGG[W]WW').split('W')[1];

    dispatch(calendarOpenNextWeek(nextWeek));

    if (!fetchedWeeks.includes(nextWeekNumber)) {
      if (isPersonalWorkCalendarMode) {
        await dispatch(loadPersonalWorkCalendarData());
      } else if (isPermissionFromActiveEmployerToViewAllBusinessRecords) {
        await Promise.allSettled([
          dispatch(loadAdminCalendarRecordsDataInTimeframe()),
          dispatch(loadAdminCalendarFilesDataInTimeframe()),
        ]);
      } else {
        await dispatch(loadCalendarDataInTimeframe());
      }
    }
  }
);
